module.exports = __webpack_public_path__ + "images/blog_guide/flow02_ef7128223ad0f2767bbb36fb8e79b580.png";